import { TIKTOK } from 'constants/trackerKinds';

export const tt4bPopup = {
  title: `$t(tracker:displayKind, {"context": "${TIKTOK}"})`,
  content:
    'TikTok Pixelは「TikTok Business Extension Kit」をインストールする必要があります。インストールしますか?',
  content_edit:
    '「サードパーティサービス > TikTok」の「アセットの編集」をクリックして、TikTok ピクセルを編集しますか?',
  content_remove:
    'TikTok ピクセルを削除するには、「サードパーティサービス > TikTok」のインストールをキャンセルします。キャンセルしますか?',
  ok: 'インストールへ',
  ok_edit: '編集へ',
  ok_remove: 'キャンセルへ',
  cancel: '今は必要ない',
};
